export default __webpack_public_path__ + "scripts/resources/assignments/en/chemvlab/thermodynamics/Cobalt/assignment.json";